export function Spinner({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <span
      className={`inline-block animate-spin rounded-full border-2 border-primary-500 border-t-transparent ${className}`}
      aria-hidden="true"
    />
  );
}

export function Skeleton({ className = "" }: { className?: string }) {
  return <span className={`block animate-pulse rounded-md bg-background-200 ${className}`} aria-hidden="true" />;
}

export default function PageLoader({ label = "正在加载数据" }: { label?: string }) {
  return (
    <div className="flex min-h-[260px] w-full flex-col items-center justify-center gap-4 py-16">
      <div className="flex items-center gap-2">
        <span
          className="h-3 w-3 rounded-full bg-primary-500"
          style={{ animation: "lh-pulse-dot 1s infinite ease-in-out both" }}
        />
        <span
          className="h-3 w-3 rounded-full bg-primary-500"
          style={{ animation: "lh-pulse-dot 1s infinite ease-in-out 0.15s both" }}
        />
        <span
          className="h-3 w-3 rounded-full bg-accent-500"
          style={{ animation: "lh-pulse-dot 1s infinite ease-in-out 0.3s both" }}
        />
      </div>
      <p className="text-sm text-foreground-500">{label}</p>
    </div>
  );
}